import { Json } from '@gift/types/Json';
import { WebsiteState } from '@gift/website-state/store';
import { connect } from 'react-redux';
import React from 'react';
import { List } from '@gift/ui/components/list/List';
import { ListItem } from '@gift/ui/components/list/ListItem';

const _FontFamilyOptionList = ({
    fonts, selectedFontFamily, gap,
    onClick
}: Props) => (
    <List gap={gap}>
        {fonts.map(f => (
            <ListItem key={f.name}
                onClick={() => onClick(f.name)}
                active={f.name === selectedFontFamily}>
                <p style={{ fontFamily: f.name }}>{f.name}</p>
            </ListItem>
        ))}
    </List>
);

type Props = {
    fonts: Json.Font[],
    selectedFontFamily: string,
    onClick: (fontFamily: string) => void,
    gap?: Parameters<typeof List>[0]['gap']
};

const mapStateToProps = (state: WebsiteState) => ({
    fonts: state.fonts
});

export const FontFamilyOptionList = connect(
    mapStateToProps
)(_FontFamilyOptionList);
